import { Box, IconSize } from '@bechtel/gds';
import Portal from '@reach/portal';
import { AppSpinner } from '~/components';
import { BackdropStyled } from './styled';

export const SuspenseLoader = () => {
  return (
    <Portal>
      <BackdropStyled>
        <Box>
          <AppSpinner fillColor="white" size={IconSize.MEDIUM} />
        </Box>
      </BackdropStyled>
    </Portal>
  );
};
